<template>
  <div>
    <banner choose-int="1506061209903652865"></banner>
    <bread jup-path="/contact" jup-page="联系我们"></bread>

    <!--关于我们-->
    <div class="contact-map" style="background-size: cover">
      <div class="con w1440">
          <div class="title" style="text-align: left;">
              <h2 style="color: #2c3e50;margin-top: 10px;">联系地址</h2>
          </div>
        <div class="map clearfix">
          <div class="right" id="map">
                <q-q-map></q-q-map>
<!--            <div id="allmap" style="overflow: hidden; position: relative; z-index: 0; background-color: rgb(243, 241, 236); color: rgb(0, 0, 0); text-align: left;"><div style="overflow: visible; position: absolute; z-index: 0; left: -419px; top: 60px; cursor: url(&quot;http://api.map.baidu.com/images/openhand.cur&quot;) 8 8, default;"><div class="BMap_mask" style="position: absolute; left: 419px; top: -60px; z-index: 9; overflow: hidden; user-select: none; width: 464px; height: 200px;"></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 200;"><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 800;"></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 700;"><span class="BMap_Marker BMap_noprint" unselectable="on" "="" style="position: absolute; padding: 0px; margin: 0px; border: 0px; cursor: pointer; background: url(&quot;http://api.map.baidu.com/images/blank.gif&quot;); width: 18px; height: 18px; left: 831px; top: -41px; z-index: 19000000; user-select: none; display: none;" title=""></span></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 600;"></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 500;"><label class="BMapLabel" unselectable="on" style="position: absolute; display: none; cursor: inherit; background-color: rgb(190, 190, 190); border: 1px solid rgb(190, 190, 190); padding: 1px; white-space: nowrap; font: 12px arial, sans-serif; z-index: -20000; color: rgb(190, 190, 190);">shadow</label><label class="BMapLabel" unselectable="on" style="position: absolute; cursor: inherit; background-color: rgb(255, 255, 225); border: 1px solid rgb(140, 140, 140); padding: 1px; white-space: nowrap; font: 12px arial, sans-serif; z-index: -4876108; user-select: none; color: rgb(77, 77, 77); left: 477px; top: 299px; display: none;">点击可查看详情</label></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 400;"><span class="BMap_Marker" unselectable="on" style="position: absolute; padding: 0px; margin: 0px; border: 0px; width: 0px; height: 0px; left: 831px; top: -41px; z-index: 19000000; display: none;"><div style="position: absolute; margin: 0px; padding: 0px; width: 18px; height: 18px; overflow: hidden;"><img src="http://api.map.baidu.com/images/spotmkrs.png" style="display: block; border:none;margin-left:-166px; margin-top:0px; "></div></span></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 300;"></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 201;"></div><div style="position: absolute; height: 0px; width: 0px; left: 0px; top: 0px; z-index: 200;"></div></div><div style="position: absolute; overflow: visible; top: 0px; left: 0px; z-index: 1;"><div style="position: absolute; overflow: visible; z-index: -100; left: 651px; top: 40px; display: block; transform: translate3d(0px, 0px, 0px);"><img src="http://maponline2.bdimg.com/tile/?qt=vtile&amp;x=95147&amp;y=21735&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: -343px; top: -55px; max-width: none; opacity: 1;"><img src="http://maponline3.bdimg.com/tile/?qt=vtile&amp;x=95148&amp;y=21735&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: -87px; top: -55px; max-width: none; opacity: 1;"><img src="http://maponline1.bdimg.com/tile/?qt=vtile&amp;x=95146&amp;y=21735&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: -599px; top: -55px; max-width: none; opacity: 1;"><img src="http://maponline0.bdimg.com/tile/?qt=vtile&amp;x=95149&amp;y=21735&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: 169px; top: -55px; max-width: none; opacity: 1;"><img src="http://maponline2.bdimg.com/tile/?qt=vtile&amp;x=95146&amp;y=21736&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: -599px; top: -311px; max-width: none; opacity: 1;"><img src="http://maponline1.bdimg.com/tile/?qt=vtile&amp;x=95149&amp;y=21736&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: 169px; top: -311px; max-width: none; opacity: 1;"><img src="http://maponline3.bdimg.com/tile/?qt=vtile&amp;x=95147&amp;y=21736&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: -343px; top: -311px; max-width: none; opacity: 1;"><img src="http://maponline1.bdimg.com/tile/?qt=vtile&amp;x=95150&amp;y=21735&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: 425px; top: -55px; max-width: none; opacity: 1;"><img src="http://maponline2.bdimg.com/tile/?qt=vtile&amp;x=95150&amp;y=21736&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: 425px; top: -311px; max-width: none; opacity: 1;"><img src="http://maponline0.bdimg.com/tile/?qt=vtile&amp;x=95148&amp;y=21736&amp;z=19&amp;styles=pl&amp;scaler=1&amp;udt=20220510&amp;from=jsapi2_0" style="position: absolute; border: none; width: 256px; height: 256px; left: -87px; top: -311px; max-width: none; opacity: 1;"></div></div><div style="position: absolute; overflow: visible; top: 0px; left: 0px; z-index: 2; display: none;"><div style="position: absolute; overflow: visible; top: 0px; left: 0px; z-index: 0; display: none;"></div><div style="position: absolute; overflow: visible; top: 0px; left: 0px; z-index: 10; display: none;"></div></div><div style="position: absolute; overflow: visible; top: 0px; left: 0px; z-index: 3;"></div></div><div class="pano_close" title="退出全景" style="z-index: 1201; display: none;"></div><a class="pano_pc_indoor_exit" title="退出室内景" style="z-index: 1201; display: none;"><span style="float:right;margin-right:12px;">出口</span></a><div class=" anchorBL" style="height: 32px; position: absolute; z-index: 30; text-size-adjust: none; inset: auto auto 20px 1px;"><a title="到百度地图查看此区域" target="_blank" href="http://map.baidu.com/?sr=1" style="outline: none;"><img style="border:none;width:77px;height:32px" src="http://api.map.baidu.com/images/copyright_logo.png"></a></div><div id="zoomer" style="position:absolute;z-index:0;top:0px;left:0px;overflow:hidden;visibility:hidden;cursor:url(http://api.map.baidu.com/images/openhand.cur) 8 8,default"><div class="BMap_zoomer" style="top:0;left:0;"></div><div class="BMap_zoomer" style="top:0;right:0;"></div><div class="BMap_zoomer" style="bottom:0;left:0;"></div><div class="BMap_zoomer" style="bottom:0;right:0;"></div></div><div unselectable="on" class=" BMap_cpyCtrl BMap_noprint anchorBL" style="cursor: default; white-space: nowrap; color: black; background: none; font: 11px / 15px arial, sans-serif; inset: auto auto 2px 2px; position: absolute; z-index: 10; text-size-adjust: none;"><span _cid="1" style="display: inline;"><span style="background: rgba(255, 255, 255, 0.701961);padding: 0px 1px;line-height: 16px;display: inline;height: 16px;">©&nbsp;2022 Baidu - GS(2021)6026号 - 甲测资字11111342 - 京ICP证030173号 - Data © 长地万方</span></span></div></div>-->
          </div>
        </div>
      </div>
    </div>




    <div class="contact-tel">
      <div class="con w1440">
        <div class="title">
          <h2><span>相关业务</span>联系电话</h2>
        </div>
        <div class="contact-list">
          <div class="box" v-for="(item,index) in telList" :key="index">
            <div class="top" @click="showHide(index)">
              <h2>{{ item.name }}</h2>
              <div class="btn-right" :ref="'arrow'+index"></div>
            </div>
            <div class="bottom" :ref="'child'+index" :style="index===0?'display:block;':'display:none;'">
              <ul class="clearfix">
                <li v-for="(info) in item.content" :key="info.index"  class="clearfix">
                  <div v-if="info.name!='办公室'">
                    <h2>{{ info.name }}</h2>
                    <h3>电话：<a :href="'tel:'+info.tel">{{ info.tel }}</a></h3>
                    <!--                  <p>业务范围：{{ info.description === '' ? '-' : info.description }}</p>-->
                    <el-popover
                            placement="top-start"
                            trigger="hover"
                   >
                   <p style="font-weight: bold;text-align: center">联系{{info.name}}</p>
                   <p><el-image  style="max-height: 180px;max-width: 180px;" v-if="info.img" :src="info.img"/></p>
                      <el-button plain v-if="info.img"  icon="el-icon-user" slot="reference">联系我</el-button>
                    </el-popover>
                    <h4 v-if="info.img==''||info.img==undefined">&nbsp;</h4>
                    <h4 v-if="info.img==''||info.img==undefined">&nbsp;</h4>
                  </div>
                  <div v-else >
                    <h2>{{ info.name }}</h2>
                    <h3>电话：<a :href="'tel:'+info.tel">{{ info.tel }}</a></h3>
                    <!--                  <p>业务范围：{{ info.description === '' ? '-' : info.description }}</p>-->
<!--                    <h4>云南钢友一号园区203室</h4>-->
<!--                    <h4>云南钢友园区</h4>-->
                    <div v-if="info.img==''||info.img==undefined" class="el-button1">&nbsp;</div>
<!--                    <h4>办公时间 :周一至周五 08:30~18:00</h4>-->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <customFooter></customFooter>
  </div>
</template>

<script>
import customFooter from "@/components/footer/footer";
import Bread from "@/components/bread/Bread";
import Banner from "@/components/banner/Banner";
import Contact from "@/components/about/contact.json"
import QQMap from "@/components/map/QQMap";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Contact",
  components: {
    customFooter,
    Bread,
    Banner,
    QQMap
  },
  data() {
    return {
      telList: Contact,
      image: require('../../assets/img/contact/tu.jpg')
    }
  },
  methods: {
    showHide(index) {
      if (this.$refs["child" + index][0].style.display === 'none') {
        this.$refs["child" + index][0].style.display = 'block'
        this.$refs["arrow" + index][0].style.transform = 'rotateX(0deg)'
      } else {
        this.$refs["child" + index][0].style.display = 'none'
        this.$refs["arrow" + index][0].style.transform = 'rotateX(180deg)'
      }
    }
  }

}

</script>

<style scoped>
  .el-button.is-active,
  .el-button:active {
    background: #fff;
    border-color: #DCDFE6;
    color: #222b36;
  }

  .el-button:focus,
  .el-button:hover {
    background: #fff;
    border-color: #DCDFE6;
    color: #222b36;
  }

  .el-button {
    color: #222b36;
    background-color: #fff;
    border-color: #DCDFE6;
  }


  .el-button1.is-active,
  .el-button1:active {
    background: #fff;
    border-color: #DCDFE6;
    color: #222b36;
  }

  .el-button1:focus,
  .el-button1:hover {
    background: #fff;
    border-color: #DCDFE6;
    color: #222b36;
  }

  .el-button1 {
    color: #222b36;
    background-color: #fff;
    border-color: #DCDFE6;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
  }



</style>
